

























































import { TextType } from 'expangine-runtime';
import { TextMarkdownOptions } from './TextMarkdownTypes';
import TypeInputBase from '../TypeInputBase';


export default TypeInputBase<TextType, TextMarkdownOptions, string>(String).extend({
  name: 'TextMarkdown',
  data: () => ({
    tab: 0,
    columnMode: false,
  }),
  computed: {
    hasHint(): boolean {
      return !this.hideHint;
    },
    hideHint(): boolean {
      return !this.settings.options.hint;
    },
  },
  methods: {
    toggleColumnMode() {
      this.columnMode = !this.columnMode;
      this.tab = this.columnMode ? 1 : 0;
    },
  },
});
